import React from 'react';
import * as Headless from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import type { ChatSource } from '@archie/api-shared';
import ConversationSourcesPanel from './ConversationSourcesPanel';

interface SourcesDialogProps {
  open: boolean;
  onClose: () => void;
  sources: ChatSource[];
  highlightedKey: string | null;
}

const SourcesDialog: React.FC<SourcesDialogProps> = ({ open, onClose, sources, highlightedKey }) => {
  return (
    <Headless.Dialog open={open} onClose={onClose} className="relative z-50">
      <Headless.DialogBackdrop
        transition
        className="fixed inset-0 bg-zinc-950/25 transition duration-150 data-closed:opacity-0 data-enter:ease-out data-leave:ease-in dark:bg-zinc-950/50"
      />
      <div className="fixed inset-0 flex justify-end">
        <Headless.DialogPanel
          transition
          className="w-full max-w-[360px] bg-(--color-surface-page) shadow-xl border-l border-(--color-border-default) flex flex-col transition duration-200 will-change-transform data-closed:translate-x-full data-enter:ease-out data-leave:ease-in"
        >
          <div className="flex items-center justify-end px-2 py-2 border-b border-(--color-border-default)">
            <button
              type="button"
              onClick={onClose}
              aria-label="Close sources panel"
              className="p-1.5 rounded-md text-(--color-text-muted) hover:bg-(--color-surface-subtle)"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
          <div className="flex-1 min-h-0">
            <ConversationSourcesPanel sources={sources} highlightedKey={highlightedKey} />
          </div>
        </Headless.DialogPanel>
      </div>
    </Headless.Dialog>
  );
};

export default SourcesDialog;
